import { SCREEN } from "helper/roleChecker/Screens";
import { lazy } from "react";

import pathRoutes from "routes/pathRoutes";

const MainPage = lazy(() => import("./Pages/Main"));

export const personnelInformationRoutes = [
  {
    page: MainPage,
    path: pathRoutes.personnelInformation,
    screenCode: SCREEN.IP_002,
  },
];
